import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function MasterLogin() {
  const [userId, setUserId] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      const superRes = await fetch(
        'https://digischoolweb-default-rtdb.firebaseio.com/adL/superAdmin.json'
      );
      const superData = await superRes.json();

      if (superData && userId === superData.id && password === superData.pass) {
        localStorage.setItem('isAuthenticated', 'true');
        localStorage.setItem('status', 'superAdmin');
        navigate('/');
        return;
      }

      const adminRes = await fetch(
        'https://digischoolweb-default-rtdb.firebaseio.com/adL/admins.json'
      );
      const adminData = await adminRes.json();

      const matchedAdmin = Object.values(adminData).find(
        (admin) => admin.id === userId && admin.pass === password
      );

      if (matchedAdmin) {
        localStorage.setItem('isAuthenticated', 'true');
        localStorage.setItem('status', 'admin');
        navigate('/');
        return;
      }

      alert('Incorrect username or password');
    } catch (error) {
      console.error('Login error:', error);
      alert('Login failed. Please try again.');
    }
  };

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      background: 'linear-gradient(135deg, #e0eafc, #cfdef3)',
      fontFamily: 'Arial, sans-serif'
    }}>
      <div style={{
        background: '#fff',
        padding: '2.5rem',
        borderRadius: '12px',
        boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)',
        width: '100%',
        maxWidth: '400px',
        textAlign: 'center'
      }}>
        <h2 style={{
          marginBottom: '1.5rem',
          color: '#333',
          fontSize: '1.75rem'
        }}>🔒 Master Login</h2>

        <input
          type="text"
          value={userId}
          onChange={(e) => setUserId(e.target.value)}
          placeholder="Enter User ID"
          style={{
            width: '100%',
            padding: '0.75rem 1rem',
            marginBottom: '1rem',
            border: '1px solid #ccc',
            borderRadius: '8px',
            fontSize: '1rem'
          }}
        />
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Enter Password"
          style={{
            width: '100%',
            padding: '0.75rem 1rem',
            marginBottom: '1.5rem',
            border: '1px solid #ccc',
            borderRadius: '8px',
            fontSize: '1rem'
          }}
        />

        <button
          onClick={handleLogin}
          style={{
            width: '100%',
            padding: '0.75rem 1rem',
            background: '#4f46e5',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            fontSize: '1rem',
            fontWeight: 'bold',
            cursor: 'pointer',
            transition: 'background 0.3s ease'
          }}
          onMouseOver={(e) => (e.target.style.background = '#4338ca')}
          onMouseOut={(e) => (e.target.style.background = '#4f46e5')}
        >
          Login
        </button>
      </div>
    </div>
  );
}

export default MasterLogin;
